import React from "react";
import { Trash2 } from "lucide-react";
import Tooltip from "../ui/Tooltip";

const PANEL_DELETE_ICON_BUTTON_CLASS =
  "inline-flex items-center justify-center rounded p-1 text-gray-400 transition-colors duration-150 hover:text-red-400 focus:outline-none focus-visible:outline-none disabled:opacity-50 disabled:cursor-not-allowed";

const REVEAL_ON_PARENT_HOVER_CLASS =
  "opacity-0 pointer-events-none transition-opacity duration-150 group-hover:opacity-100 group-hover:pointer-events-auto";

const PanelDeleteIconButton = ({
  onClick,
  disabled = false,
  ariaLabel = "Delete",
  title,
  className = "",
  iconClassName = "w-4 h-4",
  revealOnParentHover = false,
}) => {
  const hoverRevealClass = revealOnParentHover ? REVEAL_ON_PARENT_HOVER_CLASS : "";
  const button = (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`${PANEL_DELETE_ICON_BUTTON_CLASS} ${hoverRevealClass} ${className}`.trim()}
    >
      <Trash2 className={iconClassName} />
    </button>
  );

  return <Tooltip content={title ?? ariaLabel}>{button}</Tooltip>;
};

export default PanelDeleteIconButton;
